import React from "react";
import Indentification from "../../../../elements/Indentification";
import { formatTime, initialsValue } from "../../../../../helpers";
import Tooltip from "../../../../elements/Tooltip";
import { classNames } from "../../../../../helpers/classNames";

const ChatMenuItem = ({
  selectChatHandler = () => {},
  chat = {},
  activeChatId,
}) => {
  return (
    <div
      onClick={selectChatHandler}
      className="group zoom-in border-b border-gray-200 pb-2"
    >
      <div
        className={classNames(
          "relative flex items-center px-3 py-2 cursor-pointer box rounded-xl group-hover:bg-theme-1 group-hover:dark:bg-theme-1  bg-white group-hover:bg-primary transition-all duration-500",
          activeChatId === chat?._id ? "bg-primary" : ""
        )}
      >
        <div className="flex-none w-12 h-12 mr-1 image-fit">
          <Indentification
            image={chat?.avatar}
            initial={initialsValue(chat?.name)}
            size="lg"
          />
        </div>
        <div className="ml-2 overflow-hidden w-full">
          <div
            className={classNames(
              "font-medium text-sm xl:text-base group-hover:text-white whitespace-nowrap truncate flex items-center",
              activeChatId === chat?._id ? "text-white" : ""
            )}
          >
            {chat?.name}
            {chat?.unreadCount > 0 && (
              <span className="min-w-5 w-5 h-5 font-[10px] rounded-full bg-primary text-white ml-auto flex items-center justify-center">
                {chat?.unreadCount > 99 ? "99+" : chat?.unreadCount}
              </span>
            )}
          </div>
          <div
            className={classNames(
              "text-opacity-80 text-xs xl:text-sm group-hover:text-white  text-gray-500 w-4/5 truncate mt-0.5 group-[.chat-list--active]:text-white dark:text-slate-400",
              activeChatId === chat?._id ? "text-white" : ""
            )}
          >
            {chat?.latestMessage?.message || "-"}
          </div>
          <div className="flex flex-col">
            <div
              className={classNames(
                "text-xs text-gray-400 group-hover:text-white whitespace-nowrap text-opacity-80 flex w-full justify-end",
                activeChatId === chat?._id ? "text-white" : ""
              )}
            >
              {
                formatTime(
                  chat?.latestMessage?.sentAt || chat?.createdAt
                ).split(",")?.[0]
              }
            </div>
          </div>
        </div>
        {/* <div className="flex flex-col">
          <div className="text-xs font-medium text-gray-400 group-hover:text-white whitespace-nowrap text-opacity-80 flex w-full justify-end">
            {
              formatTime(chat?.latestMessage?.sentAt || chat?.createdAt).split(
                ","
              )?.[0]
            }
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ChatMenuItem;
